import OneActivePharmacist from './OneActivePharmacist';

export default OneActivePharmacist;
